import { cva } from "class-variance-authority";

const stylesHeaderWrapper = cva(
  "w-full h-[64px] px-[16px] z-[1100] flex items-center justify-between top-0 left-0 right-0"
);

const stylesText = cva("", {
  variants: {
    mode: {
      light: "text-light-label hover:text-light-primary",
      dark: "text-dark-label hover:text-dark-primary"
    }
  }
});
const stylesGroupText = cva("", {
  variants: {
    mode: {
      light: "text-light-label hover:text-light-primary group-hover:text-light-primary",
      dark: "text-dark-label hover:text-dark-primary group-hover:text-dark-primary"
    }
  }
});

const stylesLogo = cva("", {
  variants: {
    mode: {
      light: "text-light-label",
      dark: "text-dark-primary"
    }
  }
});

const iconStyles = cva("mr-[16px] flex-shrink-0", {
  variants: {
    mode: {
      light: "text-[#312215]",
      dark: "text-[#D7B09B]"
    }
  }
});

const dropDownStylesText = cva("", {
  variants: {
    mode: {
      light: "text-light-label",
      dark: "text-dark-label"
    }
  }
});

const dropDownStylesDesText = cva("", {
  variants: {
    mode: {
      light: "text-light-label-40",
      dark: "text-dark-label-40"
    }
  }
});

const stylesHover = cva("flex items-center text-[14px] font-medium cursor-pointer", {
  variants: {
    mode: {
      light: "hover:bg-light-fill-primary hover:text-light-primary",
      dark: "hover:bg-dark-fill-primary hover:text-dark-primary"
    }
  }
});

const stylesBg = cva("", {
  variants: {
    mode: {
      light: "bg-light-background",
      dark: "bg-light-background"
    }
  }
});

const stylesHeader = cva("", {
  variants: {
    mode: {
      dark: "bg-dark-background",
      light: "bg-light-background"
    }
  }
});

const stylesHeaderSticky = cva("", {
  variants: {
    mode: {
      dark: "bg-dark-background",
      light: "bg-light-background"
    }
  }
});

const activeRouteStyles = cva("", {
  variants: {
    mode: {
      dark: "text-dark-primary",
      light: "text-light-primary"
    }
  }
});

const stylesLiveTrading = cva(
  "flex justify-center items-center px-[12px] py-[5px] rounded-[20px] text-[14px] leading-[20px] mr-[24px] cursor-pointer",
  {
    variants: {
      mode: {
        light: "text-light-primary bg-light-primary-14",
        dark: "text-dark-primary bg-dark-primary-14"
      }
    }
  }
);

const stylesDemoTrading = cva(
  "px-[12px] py-[2px] rounded-[20px] text-[14px] leading-[20px] text-light-second ml-[24px]",
  {
    variants: {
      mode: {
        light: "bg-gradient-to-r from-[#FFEA45] to-[#1FF982]",
        dark: "bg-gradient-to-r from-[#FFEA45] to-[#1FF982]"
      }
    }
  }
);

const stylesLine = cva("w-[2px] h-[16px] bg-base-line-primary", {
  variants: {
    mode: {
      light: "bg-light-line-primary",
      dark: "bg-dark-line-primary"
    }
  }
});

export {
  stylesHeaderWrapper,
  stylesText,
  stylesGroupText,
  stylesHover,
  stylesBg,
  dropDownStylesText,
  stylesHeader,
  stylesHeaderSticky,
  dropDownStylesDesText,
  iconStyles,
  activeRouteStyles,
  stylesLiveTrading,
  stylesDemoTrading,
  stylesLogo,
  stylesLine
};
